import React, { useEffect, useState } from "react";
import { Image, LI, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import ProfileBox from "./ProfileBox";
import { userProfile } from "../../../../Api/apiUtils";
import { isAllowedAdminRoleFromProfile, pickPrimaryAdminRole, clearAuthAndRedirectToLogin, notifyProfileDataUpdated } from "../../../../utils/permissions";

const UserProfile = () => {
  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    role: "",
    profilePhoto: null,
    mobileNumber: "",
    emailId: ""
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      const userId = localStorage.getItem("userId");
      const credentialId = localStorage.getItem("credentialId");
      try {
        const response = await userProfile(userId, credentialId);
        
        if (response && response) {
          const { firstName, lastName, role, authorities, profilePhoto, mobileNumber, emailId, id, countryCode } = response;
          let loginAuthorities: unknown[] = [];
          try {
            const loginRaw = localStorage.getItem("userProfileData");
            if (loginRaw) {
              loginAuthorities = JSON.parse(loginRaw)?.authorities || [];
            }
          } catch {
            loginAuthorities = [];
          }
          const combinedRoles = [role, authorities, loginAuthorities];
          if (!combinedRoles.some((value) => isAllowedAdminRoleFromProfile(value))) {
            clearAuthAndRedirectToLogin();
            return;
          }
          const primaryRole = pickPrimaryAdminRole(role)
            || pickPrimaryAdminRole(authorities)
            || pickPrimaryAdminRole(loginAuthorities);
          localStorage.setItem("profileData", JSON.stringify({
            firstName: firstName ?? "",
            lastName: lastName ?? "",
            countryCode: countryCode ?? "",
            role: primaryRole || role || "",
            profilePhoto: profilePhoto ?? null,
            mobileNumber: mobileNumber ?? "",
            emailId: emailId ?? "",
            userId:id ??  ""
          }));
          notifyProfileDataUpdated();
          setProfile({
            firstName: firstName ?? "",
            lastName: lastName ?? "",
            role: primaryRole || (typeof role === "string" ? role : "") || "",
            profilePhoto: profilePhoto ?? null,
            mobileNumber: mobileNumber ?? "",
            emailId: emailId ?? ""
          });

          console.log("data-profile", profile)
          if (window.mixpanel && userId) {
            window.mixpanel.people.set({
              $first_name: firstName ?? "",
              $last_name: lastName ?? "",
              $email: emailId ?? "",
              $phone: mobileNumber ?? "",
              Role: primaryRole || role || "",
              ProfilePhoto: profilePhoto ?? ""
            });
          }
        }
      } catch (error: any) {
        console.error("Failed to fetch profile data", error);
        const status = error?.response?.status;
        if (status === 400 || status === 401) {
          clearAuthAndRedirectToLogin();
          return;
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  if (loading) {
    return (
      <LI className="profile-nav onhover-dropdown px-0 py-0">
        <div className="d-flex profile-media align-items-center">
          <Image className="img-30" src={dynamicImage("dashboard/profile.png")} alt="Loading..." />
          <div className="flex-grow-1">
            <span>Loading...</span>
          </div>
        </div>
      </LI>
    );
  }

  if (error) {
    return (
      <LI className="profile-nav onhover-dropdown px-0 py-0">
        <div className="d-flex profile-media align-items-center">
          <Image className="img-30" src={dynamicImage("dashboard/profile.png")} alt="Error" />
          <div className="flex-grow-1">
            <span>Error loading profile</span>
            <P className="text-danger small">{error}</P>
          </div>
        </div>
      </LI>
    );
  }

  return (
    <LI className="profile-nav onhover-dropdown px-0 py-0">
      <div className="d-flex profile-media align-items-center">
        <Image className="img-30" src={profile.profilePhoto || dynamicImage("dashboard/profile.png")} alt="user" />
        <div className="flex-grow-1">
          <span>{profile.firstName || "User"}</span>
      <P>  <span>{profile.emailId || "User"}</span></P>
          <P className="mb-0 font-outfit">
            {profile.role || "Role"}
            <i className="fa fa-angle-down" />
          </P>
        </div>
      </div>
      <ProfileBox />
    </LI>
  );
};

export default UserProfile;